import _ from 'lodash'

export function getOrderTypes (settingsBlob) {
  return _.get(settingsBlob, 'orderTypes.types', [])
}

export function getActiveOrderTypes (settingsBlob) {
  return getOrderTypes(settingsBlob).filter(it => it.activePOS || it.activeOnline)
}

export function isOrderTypeActive (code, settingsBlob) {
  return getActiveOrderTypes(settingsBlob).find(it => it.code === code) !== undefined
}

export function getOrderTypesActiveInPOS (settingsBlob) {
  return getOrderTypes(settingsBlob).filter(it => it.activePOS)
}

export function getOrderTypesActiveInOnline (settingsBlob) {
  return getOrderTypes(settingsBlob).filter(it => it.activeOnline)
}

export function getOrderType (orderTypes, id) {
  return orderTypes.find(next => next.id === id)
}

export function isOrderTypeActivePOS (orderTypes, id) {
  return _.get(getOrderType(orderTypes, id), 'activePOS', false)
}

export function isOrderTypeActiveOnline (orderTypes, id) {
  return _.get(getOrderType(orderTypes, id), 'activeOnline', false)
}

export function isOrderTypeActiveKiosk (orderTypes, id) {
  return _.get(getOrderType(orderTypes, id), 'activeKiosk', false)
}

export function isOrderTypeActiveSms (orderTypes, id) {
  return _.get(getOrderType(orderTypes, id), 'activeSms', false)
}

export function isOrderTypeActiveOnlineOrPOS (orderTypes, id) {
  return isOrderTypeActiveOnline(orderTypes, id) || isOrderTypeActivePOS(orderTypes, id)
}

export function isOrderTypeAvailableOnline (orderTypes, id) {
  return _.get(getOrderType(orderTypes, id), 'availableOnline', false)
}

export function getOrderTypeName (orderTypes, id) {
  const orderType = getOrderType(orderTypes, id)
  return orderType.customName || orderType.name
}
